"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var InitialLoaderShelf_1 = require("./InitialLoaderShelf");
var LoaderShelf_1 = require("./LoaderShelf");
var ModelShelf = /** @class */ (function () {
    function ModelShelf(id, getModel, fetchOptions) {
        var _this = this;
        this.fetchModel = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var resultModel, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this._loader.start();
                        return [4 /*yield*/, this._getModel(this._id)];
                    case 1:
                        resultModel = _a.sent();
                        this.setModel(resultModel);
                        if (this._onModelFetch) {
                            this._onModelFetch(this._model);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        if (this._onModelFetchError) {
                            this._onModelFetchError(e_1);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this._initialLoader.done();
                        this._loader.end();
                        if (this._onFinishFetch) {
                            this._onFinishFetch();
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.setModel = function (model) {
            _this._model = model;
        };
        this._id = id;
        this._getModel = getModel;
        this._loader = new LoaderShelf_1.default();
        this._initialLoader = new InitialLoaderShelf_1.default();
        if (fetchOptions) {
            this._onModelFetch = fetchOptions.onModelFetch;
            this._onModelFetchError = fetchOptions.onModelFetchError;
            this._onFinishFetch = fetchOptions.onFinishFetch;
        }
        mobx_1.makeAutoObservable(this);
        this.fetchModel();
    }
    Object.defineProperty(ModelShelf.prototype, "initialLoader", {
        get: function () {
            return this._initialLoader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelShelf.prototype, "loader", {
        get: function () {
            return this._loader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelShelf.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: false,
        configurable: true
    });
    return ModelShelf;
}());
exports.default = ModelShelf;
